export const environment = {
    name: 'dev',
    apiEndpoint: 'https://ljky539bka.execute-api.us-east-1.amazonaws.com/prod',
    platformApiEndpoint: 'https://d3hdxtmuue.execute-api.us-east-1.amazonaws.com/prod',
    leaderboardRefreshSeconds: 10
}
